import { teamHasDialler } from "@sourcewhale/shared/src/assets/js/src/general/licenses";
import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
import { derived } from "svelte/store";

export const diallerRequestedStore = derived([userStore], ([$userStore]) => {
  const { diallerRequested = false } = $userStore || {}; // empty dict to prevent error
  return diallerRequested;
});

export const displayDiallerPromoStore = derived(
  [userStore],
  ([$userStore]) =>
    !teamHasDialler(false, $userStore) &&
    !($userStore.notetakerPlan && $userStore.externalDiallers?.length),
);
